import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { getOpeningOrderIncentivesInfo } from "@faire/retailer-visitor-shared/serialized-data/getOpeningOrderIncentivesInfo";
import { useStore } from "@faire/retailer-visitor-shared/stores/domain/OpeningOrderIncentivesContextStore";
import { intlDate } from "@faire/web--source/common/localization/date-fns/intlDate";
import { Storage } from "@faire/web--source/common/Storage";
import { trackPricingOpeningOrderIncentivesViewOfferBannerView } from "@faire/web-api--source/events/pricing/view/openingOrderIncentivesViewOfferBanner";
import differenceInHours from "date-fns/differenceInHours";
import once from "lodash/once";
import { useCallback, useMemo } from "react";
var isDrivenFromEmailStorageKey = "OpeningOrderIncentivesIsDrivenFromEmail";
export var useOpeningOrderIncentives = function() {
    var _useStore = _sliced_to_array(useStore([
        "currentTime"
    ]), 2), currentTime = _useStore[0].currentTime, _ = _useStore[1];
    var _getOpeningOrderIncentivesInfo = getOpeningOrderIncentivesInfo(), discount_bps = _getOpeningOrderIncentivesInfo.discount_bps, discount_bps_cap_amount = _getOpeningOrderIncentivesInfo.discount_bps_cap_amount, expires_at = _getOpeningOrderIncentivesInfo.expires_at, is_retailer_eligible = _getOpeningOrderIncentivesInfo.is_retailer_eligible;
    var showOpeningOrderIncentives = is_retailer_eligible && expires_at && currentTime < expires_at;
    var numberOfHoursRemaining = expires_at && differenceInHours(expires_at, currentTime);
    var trackOOIBannerViewEvent = useCallback(function() {
        return once(trackPricingOpeningOrderIncentivesViewOfferBannerView);
    }, []);
    var openingOrderIncentivesProps = useMemo(function() {
        if (!expires_at || !discount_bps_cap_amount || !discount_bps) {
            return undefined;
        }
        return {
            endDate: intlDate(expires_at, "MMMM d"),
            endDateWithTimezone: intlDate(expires_at, "PPpx"),
            discountPercentage: discount_bps / 100,
            discountCapAmount: discount_bps_cap_amount
        };
    }, [
        discount_bps,
        discount_bps_cap_amount,
        expires_at
    ]);
    var isDrivenFromMarketingEmail = !!Storage.session.getItem(isDrivenFromEmailStorageKey);
    return {
        isDrivenFromMarketingEmail: isDrivenFromMarketingEmail,
        numberOfHoursRemaining: numberOfHoursRemaining,
        openingOrderIncentivesProps: openingOrderIncentivesProps,
        showOpeningOrderIncentives: showOpeningOrderIncentives,
        trackOOIBannerViewEvent: trackOOIBannerViewEvent
    };
};
